module.exports = __webpack_public_path__ + "img/default.0393bc8b.png";